export enum DriveType {
  CutwiseDrive = 1,
  DmDrive = 2,
  CutwiseSpectrum = 3,
  CutwiseProjects = 4,
}
